/*
document.addEventListener("DOMContentLoaded", function(){
  // Handler when the DOM is fully loaded
});
*/

window.onload = function() {  


/*
  
  // 아이피 체크 - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
  let ip_arr = ['115.91.246.173','58.226.35.87','61.254.81.228','116.41.171.152'
                ,'58.239.63.99','172.30.1.35','121.138.108.252','106.102.128.125'
                ,'218.50.244.92','58.124.36.98'];

  
  
  // 접속지 아이피가 허용 아이피 목록(재송 사무실 등)에 없는 경우에만 작동 - - - - - - - - - - - - - - - - - - - - - - - - - - -
  $.getJSON('https://jsonip.com/?callback=?').done(function(data) {
    let ip_address = window.JSON.parse(JSON.stringify(data, null, 2));
    ip_address = ip_address.ip;
    
    if(! ip_arr.includes(ip_address)) {  // 접속지 아이피가 허용 아이피 목록(재송 사무실 등)에 없는 경우에만 작동 
      	//console.log(ip_address);

*/
      
      
        // 접속 국가 코드 확인 # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # #

          var type = navigator.appName;
          if (type == 'Netscape') {
              var lang_code = navigator.language;
          } else {
              var lang_code = navigator.userLanguage;
          }

          //console.log(lang_code);
          // out : ko-KR

          var country_code = lang_code.substr(0, 2);
          //console.log(country_code);
          // out : ko  


        // 접속 기기 - 모바일 여부 확인 # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # #

        var device_chk = '';

        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
          // true for mobile device
          //document.write("mobile device");
          device_chk = 'mobile';
        }else{
          // false for not mobile device
          //document.write("not mobile device");
          //device_chk = 'pc';
        }


        //console.log(device_chk +'<<< device');

        /* 언어 확인 # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # */

        var setCookieLang = function(name, value, exp) {
        var date = new Date();
          date.setTime(date.getTime() + exp*24*60*60*1000);
          document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
        };

        var getCookieLang = function(name) {
          var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
          return value? value[2] : null;
        };


        var lang_init = '';
        var label_test = '';
        var elmtClass = document.getElementsByClassName("wgcurrent");
        Array.prototype.forEach.call(elmtClass, function(element) {
          lang_init = element.dataset.l;

          label_test = lang_init;
          if(lang_code != null && lang_code != 'null' && lang_code != '') {
            label_test += '*' + lang_code;
          }
          if(device_chk != '') {
            label_test += '*'+ device_chk;
          }

        });
        //console.log(label_test + '<<< label_test');
        //console.log(lang_init + '<<< lang_init');

        var lang_current = getCookieLang("lang_chg");
        //console.log(lang_current + '<<< lang_current');
        if(lang_current == null && lang_current != 'null' && lang_init != '') {
          // setCookie(변수이름, 변수값, 기간);
          setCookieLang("lang_chg", lang_init, 1/10); // 24시간 기준 1/10
        }


        // [초기화] setCookie(변수이름, 변수값, 기간);
        setCookieLang("lang_chg", lang_init, 1/1000);
        //var lang_val_get = getCookieLang("lang_chg");
        //console.log(lang_val_get + '<<< lang_val_get');




        /* 언어선택 버튼 클릭 # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # */

          var els = document.querySelectorAll("li.wg-li a");
          var lang_var = '';
          Array.prototype.forEach.call(els, function(element) {
            element.addEventListener("click", function() {

              var elmtClass = document.getElementsByClassName("wgcurrent");
              Array.prototype.forEach.call(elmtClass, function(element) {
                lang_var = element.dataset.l;
              });

              var ga_cate = '언어변경';
              var ga_action = 'Lang_' + lang_var;
              var ga_label = '언어변경버튼_' + lang_var;

              if(lang_code != null && lang_code != 'null' && lang_code != '') {
                ga_label += '*' + lang_code;
              }
              if(device_chk != '') {
                ga_label += '*' + device_chk;
              }

              // setCookie(변수이름, 변수값, 기간);
              setCookieLang("lang_chg", lang_var, 1/10); // 24시간 기준 1/10

              //console.log(ga_cate+','+ga_action+','+ga_label);
              //ga('send','event',ga_cate,ga_action,ga_label);
              try {
                ga('send','event',ga_cate,ga_action,ga_label);
              } catch {
              }

            });
          });





        /* 버튼에 직접 세팅한 이벤트 처리 부분 ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ ▼ */


          /* [예제]
           | <button type="submit" name="add" id="AddToCart-7329170227420" class="btn btn--full add-to-cart btn--secondary ga_evt" 
                  data-ga_cate="상품상세페이지" 
                  data-ga_action="AddToCart_Click" 
                  data-ga_label="상품상세AddToCart버튼">
              <span id="AddToCartText-7329170227420" data-default-text="Add to cart">Add to cart</span>
            </button>
           |
           | Product > Add To Cart
           | Product > View Cart [Ajax 우상단]
           | Product > Check out [Ajax 우상단]
           | Logo
           | 
          */

                
          
          // <!-- Event snippet for 장바구니 추가 conversion page
          // your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button. -->

          function gtag_report_conversion(url,current_price) {

            var callback = function () {
              if (typeof(url) != 'undefined') {
                window.location = url;
              }
            };
            
            gtag('event', 'conversion', {
                'send_to': 'AW-17285883461/uxiKCNepseYaEMXMxrJA',
                'value': current_price,
                'currency': 'USD',
                'event_callback': callback
            });
            
            //console.log(url);
            //console.log(current_price);
            
            return false;
          }
              
              

          var elmtClass = document.getElementsByClassName("ga_evt");
          Array.prototype.forEach.call(elmtClass, function(element) {
            element.addEventListener("click", function() {

              var ga_cate = this.dataset.ga_cate;
              var ga_action = this.dataset.ga_action;
              var ga_label = this.dataset.ga_label;

              //console.log(ga_cate+','+ga_action+','+ga_label);

              // getCookie(변수이름)
              var lang_val = getCookieLang("lang_chg");
              //console.log("쿠키 lang_val변수에 저장된 값: "+lang_val);

              if(lang_val != '') {
                ga_label += '#';
                ga_label += lang_val;
              }

              if(lang_code != null && lang_code != 'null' && lang_code != '') {
                ga_label += '*' + lang_code;
              }
              if(device_chk != '') {
                ga_label += '*' + device_chk;
              }

              //ga('send','event',ga_cate,ga_action,ga_label);
              try {
                ga('send','event',ga_cate,ga_action,ga_label);
              } catch {
              }
                
                
              // 장바구니 담기
                if(ga_action == 'AddToCart') {
                  //var current_price = Math.round(this.dataset.ga_current_price / 100);
                  var current_price = this.dataset.ga_current_price;
                  //console.log(current_price);
                  
                  //var url = window.location.href;
                  var url = undefined;
                  //console.log(url);
                  gtag_report_conversion(url,current_price);
                }

            });
          });


          /*
            data-ga_cate="상품상세_AddToCart
            data-ga_action="AddToCart_Click" 
            data-ga_label="상품상세AddToCart버튼"    

            data-ga_cate="Product
            data-ga_action="AddToCart" 
            data-ga_label="상품장바구니에담기"     
          */

        /* 버튼에 직접 세팅한 이벤트 처리 부분 ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ ▲ */






        /* 상품 상세 페이지 # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # */


          /* 상품상세 - Add to Cart [직접 세팅] - - - - - - - - - - - - - - - - - - - - */
          /*
            => Snippets > product-form.liquid

            data-ga_cate="Product"
            data-ga_action="AddToCart"
            data-ga_label="상품장바구니에담기"
          */




          /* 상품상세 - Buy it now >>>> shopify-payment-button    */
          /* 상품상세 - Buy with paypal */
          /* 상품상세 - more payment options */

          var elmtClass = document.getElementsByClassName("shopify-payment-button");
          Array.prototype.forEach.call(elmtClass, function(element) {
            element.addEventListener("click", function() {

              var ga_cate = 'Product'; // '상품상세_BuyItNow';
              var ga_action = 'BuyItNow'; // 'BuyItNow_Click';
              var ga_label = '상품바로구매하기'; // '상품상세_BuyItNow버튼';

              // getCookie(변수이름)
              var lang_val = getCookieLang("lang_chg");
              if(lang_val != '') {
                ga_label += '#';
                ga_label += lang_val;
              }

              if(lang_code != null && lang_code != 'null' && lang_code != '') {
                ga_label += '*' + lang_code;
              }
              if(device_chk != '') {
                ga_label += '*' + device_chk;
              }

              //console.log(ga_cate+','+ga_action+','+ga_label);

              //('send','event',ga_cate,ga_action,ga_label);
              try {
                ga('send','event',ga_cate,ga_action,ga_label);
              } catch {
              }

            });
          });





          /* 상품상세 [Ajax 우상단] - View Cart [직접 세팅] - - - - - - - - - - - - - - - - - - - - */
          /*
            => Snippets > header-cart-drawer.liquid

            data-ga_cate="Product"
            data-ga_action="ViewCart"
            data-ga_label="상품에서장바구니가기"
          */


          /* 상품상세 [Ajax 우상단] - Check out [직접 세팅] - - - - - - - - - - - - - - - - - - - - */
          /*
            => Snippets > header-cart-drawer.liquid

            data-ga_cate="Product"
            data-ga_action="CheckOut"
            data-ga_label="상품에서장바구니결제하기"

            - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 

            var elmtClass = document.getElementsByClassName("cart__checkout");
            Array.prototype.forEach.call(elmtClass, function(element) {
              element.addEventListener("click", function() {

                var ga_cate = 'Product'; // '상품상세_Cart_CheckOut';
                var ga_action = 'CheckOut'; // 'CheckOut_Click';
                var ga_label = '상품에서장바구니결제하기'; // '상품상세_Cart_CheckOut버튼';

                //console.log(ga_cate+','+ga_action+','+ga_label);

                ga('send','event',ga_cate,ga_action,ga_label);

              });
            });

          */  





        /* 장바구니 페이지 # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # */

        /*
          => Templates > cart.liauid

            data-ga_cate="Cart"
            data-ga_action="CheckOut"
            data-ga_label="장바구니에서결제하기"

            data-ga_cate="Cart"
            data-ga_action="ContinueShopping"
            data-ga_label="계속쇼핑하기"

        */







        /* # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # 

            결제 페이지에서 check out - Continue to shipping 버튼 => 설치 안됨
            결제 페이지에서 Return to cart 버튼 => 설치 안됨

            checkout.liquid 파일 편집

            이점: 결제 Liquid 파일에 고급 사용자 지정은 Shopify Plus 판매자만 사용할 수 있습니다. 이 파일에 대한 액세스 권한을 얻으려면 Shopify Plus 지원에 문의하십시오.

            Shopify Plus 플랜에 가입한 경우checkout.liquid 레이아웃 파일에 액세스할 수 있으므로 결제 환경을 고급 사용자 지정할 수 있는 권한이 모두 제공됩니다.

        # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # */







        /* 메인 페이지  # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # # */

          /* 메인 페이지 비주얼 슬라이드 버튼 - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */  
                
            // [공통] 
            
            //var els = document.querySelectorAll(".template-index .hero__link a.btn");
                
            var els = document.querySelectorAll("a.hero__slide-link");
              
            Array.prototype.forEach.call(els, function(element) {
              element.addEventListener("click", function(event) {
                
                var href = event.target.getAttribute( 'href' );

                var ga_cate = '메인탑슬라이더';
                var ga_action = '[mainSlider]'+href;
                var ga_label = '[메인탑슬라이더]'+href;
                //console.log(ga_cate+','+ga_action+','+ga_label);

                // getCookie(변수이름)
                var lang_val = getCookieLang("lang_chg");
                if(lang_val != '') {
                  ga_label += '#';
                  ga_label += lang_val;
                }

                if(lang_code != null && lang_code != 'null' && lang_code != '') {
                  ga_label += '*' + lang_code;
                }
                if(device_chk != '') {
                  ga_label += '*' + device_chk;
                }

                //('send','event',ga_cate,ga_action,ga_label);
                try {
                  ga('send','event',ga_cate,ga_action,ga_label);
                } catch {
                }
                
              });
            });

                                  
                  
/*
    }
  });   // 사무실 아이피랑 접속지 아이피가 다른 경우에만 작동
*/
  

}